import { Trans } from 'react-i18next'

import { BuilderMenu, BuilderMenuItem, IActionRepeaterValue, IActionType } from '@makyoapp/makyo-common'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { AccordionItem } from '@/components/Accordion/Accordion'
import { ActionRepeaterV2 } from '@/components/ActionV2/ActionRepeaterV2'

/**
 * MenuItemActionAccordion is a function component that provides an interface for editing the actions of a menu item in a builder.
 */
function MenuItemActionAccordion({
  menu,
  menuIdx,
  menuItem: curMenuItem,
  menuItemIdx,
}: {
  menuIdx: number
  menu: BuilderMenu
  menuItem: BuilderMenuItem
  menuItemIdx: number
}) {
  const { updateMenu } = useAppBuilderContext()

  const handleOnChange = (actions: IActionRepeaterValue[]) => {
    updateMenu(menuIdx, (prev) => {
      prev.items[menuItemIdx].actions = actions
    })
  }

  const values = curMenuItem.actions || []

  // The menu item actions editing interface
  return (
    <AccordionItem itemId='menu-item-actions' title={<Trans>Actions</Trans>}>
      <ActionRepeaterV2
        id={curMenuItem.id}
        values={values}
        onChange={handleOnChange}
        excludeActions={[
          IActionType.CloseAlert,
          IActionType.RefreshScreen,
          IActionType.OpenMenu,
          IActionType.OpenNavDrawer,
          IActionType.ShowContextualMenu,
          IActionType.PrevItem,
          IActionType.NextItem,
          IActionType.PerformNextAction,
          IActionType.FormAddRow,
          IActionType.FormUpdateRow,

          // Temporary hide these actions
          // See https://trello.com/c/TBLyCUfh/196-multiple-item-actions-on-tables
          IActionType.ToggleValue,
          IActionType.IncrementValue,
          IActionType.UpdateRow,
          // ------------------------------------------------------------
        ]}
        triggerSource='menu-item'
      />
    </AccordionItem>
  )
}
export default MenuItemActionAccordion
